function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfieCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 106 108.4",
    style: {
      enableBackground: "new 0 0 106 108.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#e4e4e4"
    },
    cx: 53,
    cy: 53,
    r: 53
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8c8c8"
    },
    d: "M67.7 92.2S66 95.4 59.6 99c-1 .6-1.6 1.7-1.6 2.8v3.3c0 1.8-1.4 3.2-3.2 3.2H35.3c-1.8 0-3.2-1.4-3.2-3.2v-1.6c0-3-2.1-5.5-3.6-7.9-2.8-4.6-4.1-4.8-4.5-10-.2-2.7.4-10 .4-12.7 0-1.5 0-6.6-.1-11.3 0-4.6 3.7-8.4 8.3-8.4 4.3 0 5.6 2.5 9.1 3.5 2.2.6 4.5 1.1 6.8 1.3 1.6.2 2.8 1.5 2.8 3.2v.3s0 7.1-9.7 7.1c-1 .2-8.1-.8-9.7-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e5e5e5"
    },
    d: "M71.9 15.4c-7.9 1.4-37.1 11-37.1 74.4l-.3.2c-.5-.8-.8-1.7-.8-2.7V19.5c0-2.7 2.2-4.8 4.8-4.9h30.7c1 0 1.9.3 2.7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1f1f1"
    },
    d: "M74.1 19.5v67.8c0 2.7-2.2 4.8-4.8 4.8H38.5c-1.6 0-3.1-.8-4-2.2l.3-.2c0-78.5 29.2-73 37.1-74.4.5.3.9.7 1.2 1.1.7 1 1 2 1 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d8d8d"
    },
    d: "M69.3 93.8H38.5c-3.6 0-6.5-2.9-6.5-6.5V19.5c0-3.6 2.9-6.5 6.5-6.5h30.7c3.6 0 6.5 2.9 6.5 6.5v67.8c0 3.6-2.9 6.5-6.4 6.5zM38.5 16.2c-1.8 0-3.2 1.5-3.2 3.2v67.8c0 1.8 1.4 3.2 3.2 3.2h30.7c1.8 0 3.2-1.5 3.2-3.2V19.5c0-1.8-1.5-3.2-3.2-3.2H38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d8d8d"
    },
    d: "m66 14.6-2.3 4.7c-.6 1.1-1.7 1.8-2.9 1.8H47c-1.2 0-2.3-.7-2.9-1.8l-2.3-4.7H66zM62.8 87.4H45c-.9.1-1.7-.6-1.7-1.5-.1-.9.6-1.7 1.5-1.7h18.1c.9-.1 1.7.6 1.7 1.5.1.9-.6 1.7-1.5 1.7h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdbbbb"
    },
    d: "M62.8 42.1v.9l-17.4.6c2.1-1.7 12.5-7.9 13.7-9.5 2.5 1.9 3.8 4.9 3.7 8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9d9d9"
    },
    d: "M62.8 43c-.3 5.5-3.5 10.4-8.9 10.4-5.2 0-8.3-4.6-8.8-9.8 3.4-.5 6.6-1.9 9.2-4.2l8.5 3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dadada"
    },
    d: "M66 66v8.4c0 .9-.7 1.6-1.6 1.6h-21c-.9 0-1.6-.7-1.6-1.6v-5.7l3.1-11.2c2.4-2.7 5.9-4.2 9.5-4.1 6.5.4 11.7 6 11.6 12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a1a1a1"
    },
    d: "M61.2 68v8.1H58V68c0-.9.7-1.6 1.6-1.6.9 0 1.6.7 1.6 1.6zM49.9 68v8.1h-3.2V68c.1-.9.9-1.6 1.7-1.5.8.1 1.4.7 1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c1c1c1"
    },
    d: "M59.1 34.1c-1.4 1.9-3 3.7-4.8 5.3-2.6 2.3-5.8 3.8-9.2 4.2-.1-.5-.1-1-.1-1.5 0-5.8 4-9.7 8.9-9.7 1.9 0 3.7.6 5.2 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#afafaf"
    },
    d: "m75.8 52.5 6.6-2.7c2.5-.9 3.9-3.6 3-6.2-.9-2.5-3.6-3.9-6.2-3-.1 0-.3.1-.4.2L75.7 42M85.4 63c0 2.7-2.2 4.8-4.8 4.8h-4.9c-2.7 0-4.8-2.2-4.8-4.8 0-2.7 2.2-4.9 4.8-4.9h4.8c2.8 0 4.9 2.2 4.9 4.9zM83.8 72.7c0 2.7-2.2 4.8-4.8 4.8h-3.3c-.6 0-1.1-.1-1.6-.3-2.5-.9-3.8-3.7-2.9-6.2.7-1.9 2.5-3.2 4.5-3.2H79c2.7.1 4.8 2.3 4.8 4.9zM82.2 82.4c0 2.7-2.2 4.9-4.8 4.9h-1.7c-2.7-.1-4.8-2.4-4.6-5.1.1-2.5 2.1-4.5 4.6-4.6h1.7c2.7 0 4.8 2.2 4.8 4.8zM32 53.4c4.3 0 6.2 2.4 9.8 3.4 2.2.6 4.5 1.1 6.8 1.3 1.6.2 2.8 1.5 2.8 3.2v.3s0 7.1-9.7 7.1c-1 .2-8.1-.8-9.7-4l-3.2-5.3 3.2-6z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfieCircle);
export default __webpack_public_path__ + "static/media/selfie-circle.6a73fcaef982bc73ccf8ec2107dd136f.svg";
export { ForwardRef as ReactComponent };